export default angular.module("ngOnboarding", ["ngSanitize"])
    .provider("ngOnboardingDefaults", function () {
        return {
            options: {
                overlay: true,
                overlayOpacity: 0.6,
                overlayClass: 'onboarding-overlay',
                popoverClass: 'onboarding-popover',
                titleClass: 'onboarding-popover-title',
                contentClass: 'onboarding-popover-content',
                arrowClass: 'onboarding-arrow',
                buttonContainerClass: 'onboarding-button-container',
                buttonClass: "onboarding-button",
                showButtons: true,
                beginButtonText: 'Comenzar &rarr;',
                nextButtonText: 'Saltar paso &rarr;',
                previousButtonText: '&larr; Anterior',
                showDoneButton: true,
                doneButtonText: 'Cerrar',
                closeButtonClass: 'onboarding-close-button',
                closeButtonText: 'X',
                stepClass: 'onboarding-step-info',
                showStepInfo: true
            },
            $get: function () {
                return this.options;
            },
            set: function (keyOrHash, value) {
                let k, v, _results;
                if (typeof keyOrHash === 'object') {
                    _results = [];
                    for (k in keyOrHash) {
                        v = keyOrHash[k];
                        _results.push(this.options[k] = v);
                    }
                    return _results;
                } else {
                    return this.options[keyOrHash] = value;
                }
            }
        };
    })
    .directive('onboardingPopover', (ngOnboardingDefaults, $sanitize, $timeout, $q, $rootScope) => {

        var firstTime = true;

            return {
                restrict: 'E',
                scope: {
                    enabled: '<',
                    steps: '<',
                    onFinishCallback: '&onFinishCallback',
                    index: '<stepIndex'
                },
                //replace: true,
                link(scope, element, attrs) {
                    let attributesToClear, curStep, setupOverlay, setupPositioning, delayPositioning = false;
                    curStep = null;
                    attributesToClear = ['title', 'top', 'right', 'bottom', 'left', 'width', 'height', 'position'];
                    scope.stepCount = scope.steps.length;
              
                    scope.reset = () => {
                        scope.enabled = false;
                        scope.index = null;
                        $timeout(() => {
                            scope.enabled = false;
                            scope.index = null;
                        })
                    };

                    scope.skip = (step) => {
                        if (angular.isNumber(step)) {
                            scope.index = step > 0 ? step - 1 : 0;
                        } else if (angular.isString(step)) {
                            for (let i = 0; i < scope.steps.length; i++) {
                                if (scope.steps[i].id === step) {
                                    scope.index = i > 0 ? i - 1 : 0;
                                    break;
                                }
                            }
                        }
                        $timeout(scope.next, 0);
                    };

                    scope.next = () => {
                        if (firstTime && scope.enabled) {
                            scope.index++;
                            if (angular.isFunction(scope.steps[scope.index - 1].actionNext)) {
                                delayPositioning = true;
                                scope.steps[scope.index - 1].actionNext().then(showOnboardMessage);
                            } else {
                                delayPositioning = false;
                                showOnboardMessage();
                            }
                        }
                    };
                    scope.previous = () => {
                        if (firstTime && scope.enabled) {
                            scope.index--;
                            if (angular.isFunction(scope.steps[scope.index + 1].actionPrev)) {
                                delayPositioning = true;
                                scope.steps[scope.index + 1].actionPrev().then(showOnboardMessage);
                            } else {
                                delayPositioning = false;
                                showOnboardMessage();
                            }
                        }
                    };
                    scope.close = () => {
                        scope.reset();
                        setupOverlay(false);
                        if (scope.onFinishCallback) {            
                            return scope.onFinishCallback();
                        }
                    };

                    $rootScope.$on('nextOnboardingStep', (event, data) => {
                        if (scope.enabled) {
                            if (!angular.isUndefined(data)) {
                                return scope.skip(data);
                            } else {
                                return $timeout(scope.next, 100);
                            }
                        }
                    });

                    $rootScope.$on('$viewContentLoaded', () => {
                        if (firstTime && scope.enabled && delayPositioning) {
                            delayPositioning = false;
                            $timeout(() => {
                                setupOverlay();
                                setupPositioning();
                                scope.$emit("EnableOnboarding");
                            }, 0);
                        }
                    });

                    $rootScope.$on('elemReady', () => {
                        // Funciona para elementos con una transicion menor de 500ms
                        if (firstTime && scope.enabled) {
                            delayPositioning = false;
                            $timeout(() => {
                                setupOverlay();
                                setupPositioning();
                            }, 500);
                        }
                    });

                    setupOverlay = (showOverlay) => {
                        if (showOverlay == null) {
                            showOverlay = true;
                        }
                        $('.onboarding-focus').removeClass('onboarding-focus');
                        if (showOverlay) {
                            if (curStep['attachTo'] && scope.overlay) {
                                return $(curStep['attachTo']).addClass('onboarding-focus');
                            }
                        }
                    };

                    function showOnboardMessage(newValue) {
                        let attr, k, v, _i, _len;

                        if (!firstTime) return;

                        if (scope.index === null) {
                            scope.enabled = false;
                            setupOverlay(false);
                            return;
                        }
                        curStep = scope.steps[scope.index];
                        scope.lastStep = scope.index + 1 === scope.steps.length;
                        scope.showNextButton = scope.index + 1 < scope.steps.length;
                        scope.showPreviousButton = scope.index > 0;
                        for (_i = 0, _len = attributesToClear.length; _i < _len; _i++) {
                            attr = attributesToClear[_i];
                            scope[attr] = null;
                        }
                        for (k in ngOnboardingDefaults) {
                            v = ngOnboardingDefaults[k];
                            if (curStep[k] === void 0) {
                                scope[k] = v;
                            }
                        }
                        for (k in curStep) {
                            v = curStep[k];
                            scope[k] = v;
                        }         

                        scope.description = $sanitize(scope.description);
                        scope.nextButtonText = $sanitize(scope.nextButtonText);
                        scope.previousButtonText = $sanitize(scope.previousButtonText);
                        scope.doneButtonText = $sanitize(scope.doneButtonText);
                        scope.closeButtonText = $sanitize(scope.closeButtonText);

                        setupOverlay();

                        if (delayPositioning) {
                            element.find('.onboarding-popover').hide();
                            $timeout(setupPositioning, 100);
                        } else {
                            setupPositioning();
                        }

                    }

                    setupPositioning = () => {

                        let popover = element.find('.onboarding-popover');
                        popover.show();

                        let attachTo, bottom, left, right, top, xMargin, yMargin, attachedElement;
                        attachTo = curStep['attachTo'];
                        scope.position = curStep['position'];
                        xMargin = 15;
                        yMargin = 15;
                        if (attachTo && (attachedElement = $(attachTo)) && attachedElement.length > 0) {
                            //if (!(scope.left || scope.right)) {
                            left = null;
                            right = null;
                            if (scope.position === 'right') {
                                left = attachedElement.offset().left + attachedElement.outerWidth() + xMargin;
                            } else if (scope.position === 'left') {
                                right = $(window).width() - attachedElement.offset().left + xMargin;
                            } else if (scope.position === 'top' || scope.position === 'bottom') {
                                let a = attachedElement.outerWidth(), b = popover.outerWidth();
                                left = attachedElement.offset().left + (a / 2) - (b / 2);
                            }
                            if (curStep['xOffset']) {
                                if (left !== null) {
                                    left = left + curStep['xOffset'];
                                }
                                if (right !== null) {
                                    right = right - curStep['xOffset'];
                                }
                            }
                            scope.left = left;
                            scope.right = right;
                            //}
                            //if (!(scope.top || scope.bottom)) {
                            top = null;
                            bottom = null;
                            if (scope.position === 'left' || scope.position === 'right') {
                                top = attachedElement.offset().top - attachedElement.outerHeight() / 2;
                            } else if (scope.position === 'bottom') {
                                top = attachedElement.offset().top + attachedElement.outerHeight() + yMargin;
                            } else if (scope.position === 'top') {
                                bottom = $(window).height() - attachedElement.offset().top + yMargin;
                            }
                            if (curStep['yOffset']) {
                                if (top !== null) {
                                    top = top + curStep['yOffset'];
                                }
                                if (bottom !== null) {
                                    bottom = bottom - curStep['yOffset'];
                                }
                            }
                            scope.top = top;
                            scope.bottom = bottom;
                            //}
                        }

                        if (attachTo && (!attachedElement || attachedElement.length === 0)) {
                            popover.hide();
                        }

                        if (scope.position && scope.position.length) {
                            return scope.positionClass = "onboarding-" + scope.position;
                        } else {
                            return scope.positionClass = null;
                        }
                    };

                    $(window).on('resize', function () {
                        if (scope.enabled) {
                            $timeout(setupPositioning, 100);
                        }
                    });

                    if (scope.steps.length && !scope.index) {
                        $timeout(showOnboardMessage, 100);
                        return scope.index = 0;
                    }
                },
                template: require('../../../../../app/views/Templates/Onboarding.html')
            };
        }
    );
